{
    "oCET5T7zwnh2AoxP__09_": {
        "key": "oCET5T7zwnh2AoxP__09_",
        "position": {
            "x": 4,
            "y": 1,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker",
        "maxhealth": 40
    },
    "q-UV94hHsDbe5XLt3BkNI": {
        "key": "q-UV94hHsDbe5XLt3BkNI",
        "position": {
            "x": 4,
            "y": 6,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/berserker",
        "maxhealth": 40
    },
    "vjIV5BB1c-Qsj_WKTsYcD": {
        "key": "vjIV5BB1c-Qsj_WKTsYcD",
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "affiliation": "bad",
        "jobKey": "hero/archer"
    }
}
